module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rankWorkTable"
  }, [_c('div', {
    staticClass: "export fr"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/exportExcel.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": _vm.exportUrl
    }
  }, [_vm._v("导出成绩")])])]), _vm._v(" "), _c('div', {
    staticClass: "workTable"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse"
    },
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("排名")]), _vm._v(" "), _c('th', [_vm._v("姓名")]), _vm._v(" "), _vm._l((_vm.collectHeader), function(item, index) {
    return _c('th', {
      key: index
    }, [_c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "score"
    }, [_vm._v(_vm._s(item.score) + "分")])])
  }), _vm._v(" "), _c('th', [_c('p', [_vm._v("总分")]), _vm._v(" "), _c('span', {
    staticClass: "score"
  }, [_vm._v(_vm._s(_vm.workScore.score) + "分")])])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.collectData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _vm._l((item.tabDatas), function(items, index) {
      return _c('td', {
        key: index
      }, [(items.moduleId != 66) ? _c('span', [_vm._v(_vm._s(items.score))]) : _vm._e(), _vm._v(" "), (items.moduleId == 66 && items.submitStatus.hasQuestion && items.submitStatus.isSubmit) ? _c('span', [_vm._v(_vm._s(items.score))]) : (items.moduleId == 66 && !items.submitStatus.hasQuestion && items.submitStatus.isSubmit) ? _c('span', [_vm._v(_vm._s('已提交' || '未提交'))]) : _vm._e()])
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.totalScore || 0))])], 2)
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a52f880","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rankWorkTable/rankWorkTable.vue
// module id = 1212
// module chunks = 1